(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hexa-accessibility"]) return;
  try {
    
  (function () {
    var KEY = 'hexa_a11y_v1';
    var root = document.getElementById('hexa-a11y-root');
    if (!root) return;
    var trigger = document.getElementById('hexa-a11y-trigger');
    var panel = document.getElementById('hexa-a11y-panel');
    var closeBtn = document.getElementById('hexa-a11y-close');
    var live = root.querySelector('.hexa-a11y-sr');
    var valEl = root.querySelector('[data-a11y-textval]');

    var TEXT = [100, 112.5, 125, 140];
    var defaults = { v: 2, links: false, contrast: 'off', invert: false, grayscale: false, readableFont: false, largeCursor: false, reduceMotion: false, textStep: 0 };
    var state = load();

    function load() {
      try {
        var raw = localStorage.getItem(KEY);
        if (!raw) return clone(defaults);
        var p = JSON.parse(raw);
        if (!p || (p.v !== 1 && p.v !== 2)) return clone(defaults);
        return {
          v: 2,
          links: !!p.links,
          contrast: p.contrast === 'high' ? 'high' : 'off',
          invert: !!p.invert,
          grayscale: !!p.grayscale,
          readableFont: !!p.readableFont,
          largeCursor: !!p.largeCursor,
          reduceMotion: !!p.reduceMotion,
          textStep: Math.min(3, Math.max(0, parseInt(p.textStep, 10) || 0))
        };
      } catch (e) { return clone(defaults); }
    }
    function clone(o) { return JSON.parse(JSON.stringify(o)); }
    function save() { try { localStorage.setItem(KEY, JSON.stringify(state)); } catch (e) {} }

    function applyClasses() {
      var c = document.documentElement.classList;
      c.toggle('a11y-links', state.links);
      c.toggle('a11y-contrast-high', state.contrast === 'high');
      c.toggle('a11y-invert', state.invert);
      c.toggle('a11y-grayscale', state.grayscale);
      c.toggle('a11y-readable-font', state.readableFont);
      c.toggle('a11y-large-cursor', state.largeCursor);
      c.toggle('a11y-reduce-motion', state.reduceMotion);
      c.remove('a11y-focus');
      c.toggle('a11y-text-1', state.textStep === 1);
      c.toggle('a11y-text-2', state.textStep === 2);
      c.toggle('a11y-text-3', state.textStep === 3);
    }

    function syncUI() {
      root.querySelectorAll('[data-a11y-toggle]').forEach(function (btn) {
        var key = btn.getAttribute('data-a11y-toggle');
        var on = key === 'contrast' ? state.contrast === 'high' : !!state[key];
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      if (valEl) valEl.textContent = TEXT[state.textStep] + '%';
    }

    function announce(msg) { if (live) { live.textContent = ''; window.setTimeout(function () { live.textContent = msg; }, 30); } }

    function commit() { applyClasses(); syncUI(); save(); }

    root.querySelectorAll('[data-a11y-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = btn.getAttribute('data-a11y-toggle');
        if (key === 'contrast') state.contrast = state.contrast === 'high' ? 'off' : 'high';
        else state[key] = !state[key];
        commit();
        var on = key === 'contrast' ? state.contrast === 'high' : !!state[key];
        announce((btn.textContent || '').trim() + ': ' + (on ? 'פעיל' : 'כבוי'));
      });
    });

    var up = root.querySelector('[data-a11y-textup]');
    var down = root.querySelector('[data-a11y-textdown]');
    if (up) up.addEventListener('click', function () { if (state.textStep < 3) { state.textStep++; commit(); announce('גודל טקסט ' + TEXT[state.textStep] + ' אחוז'); } });
    if (down) down.addEventListener('click', function () { if (state.textStep > 0) { state.textStep--; commit(); announce('גודל טקסט ' + TEXT[state.textStep] + ' אחוז'); } });

    var resetBtn = root.querySelector('[data-a11y-reset]');
    if (resetBtn) resetBtn.addEventListener('click', function () { state = clone(defaults); commit(); announce('הגדרות הנגישות אופסו'); });

    // ----- Panel open/close with focus management -----
    var lastFocused = null;
    function focusables() {
      return Array.prototype.slice.call(
        panel.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])')
      ).filter(function (el) { return !el.hasAttribute('disabled') && el.offsetParent !== null; });
    }
    function openPanel() {
      lastFocused = document.activeElement;
      panel.hidden = false;
      trigger.setAttribute('aria-expanded', 'true');
      var f = focusables();
      if (f.length) f[0].focus();
      document.addEventListener('keydown', onKeydown, true);
      document.addEventListener('click', onOutside, true);
    }
    function closePanel(returnFocus) {
      panel.hidden = true;
      trigger.setAttribute('aria-expanded', 'false');
      document.removeEventListener('keydown', onKeydown, true);
      document.removeEventListener('click', onOutside, true);
      if (returnFocus !== false && lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
      else if (returnFocus !== false) trigger.focus();
    }
    function onOutside(e) { if (!panel.hidden && !panel.contains(e.target) && e.target !== trigger && !trigger.contains(e.target)) closePanel(false); }
    function onKeydown(e) {
      if (e.key === 'Escape') { e.preventDefault(); closePanel(true); return; }
      if (e.key === 'Tab') {
        var f = focusables();
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    }
    trigger.addEventListener('click', function () { panel.hidden ? openPanel() : closePanel(true); });
    if (closeBtn) closeBtn.addEventListener('click', function () { closePanel(true); });

    // Alt+A (layout-independent via e.code)
    document.addEventListener('keydown', function (e) {
      if (e.altKey && !e.ctrlKey && !e.metaKey && !e.shiftKey && e.code === 'KeyA') {
        e.preventDefault();
        panel.hidden ? openPanel() : closePanel(true);
      }
    });

    // Initial paint (bootstrap already applied classes pre-hydration; keep UI in sync)
    applyClasses();
    syncUI();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
